import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import {
  AutoCompleteRemoto,
  TextInput,
  SelectInput,
} from '../../../Components';
import useDebounceCustom from '../../../hooks/useDebounce';
import { api, getListAPI } from '../../../services';
import {
  STATUS_ATIVO,
  TURNO_MANHA,
  ESTADO_FISICO_CONGELADO,
  ESTADO_FISICO_RESFRIADO,
  ESTADO_FISICO_SECO,
} from '../../../utils';

const optionsEstadoFisico = [
  { label: 'Congelado', value: ESTADO_FISICO_CONGELADO },
  { label: 'Resfriado', value: ESTADO_FISICO_RESFRIADO },
  { label: 'Seco', value: ESTADO_FISICO_SECO },
];

const FILTROS_DISPONIVEIS = [
  { key: 'categoria', label: 'Categoria' },
  { key: 'familia', label: 'Família' },
  { key: 'local', label: 'Local/Setor' },
  { key: 'fornecedor', label: 'Fornecedor' },
  { key: 'unidade', label: 'Unidade' },
  { key: 'estadoFisico', label: 'Estado Físico' },
  { key: 'codigo', label: 'Código de barras' },
];

const PRODUTOS_PER_PAGE = 20;

const ACAO_SEM_CODINOME = 'sem_codinome';
const ACAO_DISTRIBUIR = 'distribuir';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DialogoRemoverProdutos = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [codinomeOrigem, setCodinomeOrigem] = useState(null);

  const [categoria, setCategoria] = useState(null);
  const [nome, setNome] = useState('');
  const [nomeDebounce] = useDebounceCustom(nome, 500);
  const [codigo, setCodigo] = useState('');
  const [codigoDebounce] = useDebounceCustom(codigo, 500);
  const [familia, setFamilia] = useState(null);
  const [local, setLocal] = useState(null);
  const [fornecedor, setFornecedor] = useState(null);
  const [unidade, setUnidade] = useState(null);
  const [estadoFisico, setEstadoFisico] = useState('');

  const [filtrosAtivos, setFiltrosAtivos] = useState([]);
  const [anchorElFiltro, setAnchorElFiltro] = useState(null);

  const [acao, setAcao] = useState(ACAO_SEM_CODINOME);
  const [codinomesDestino, setCodinomesDestino] = useState([]);

  const [produtos, setProdutos] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [excluidos, setExcluidos] = useState(new Set());

  const [carregando, setCarregando] = useState(false);
  const [salvando, setSalvando] = useState(false);

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  function reiniciar() {
    setCodinomeOrigem(null);
    setCategoria(null);
    setNome('');
    setCodigo('');
    setFamilia(null);
    setLocal(null);
    setFornecedor(null);
    setUnidade(null);
    setEstadoFisico('');
    setFiltrosAtivos([]);
    setAnchorElFiltro(null);
    setAcao(ACAO_SEM_CODINOME);
    setCodinomesDestino([]);
    setProdutos([]);
    setTotal(0);
    setPage(0);
    setExcluidos(new Set());
    setSalvando(false);
  }

  const limparFiltro = {
    categoria: () => setCategoria(null),
    familia: () => setFamilia(null),
    local: () => setLocal(null),
    fornecedor: () => setFornecedor(null),
    unidade: () => setUnidade(null),
    estadoFisico: () => setEstadoFisico(''),
    codigo: () => setCodigo(''),
  };

  function adicionarFiltro(key) {
    setFiltrosAtivos((atuais) => [...atuais, key]);
    setAnchorElFiltro(null);
  }

  function removerFiltro(key) {
    setFiltrosAtivos((atuais) => atuais.filter((item) => item !== key));
    limparFiltro[key]();
  }

  async function carregarProdutos(paginaAlvo = page) {
    if (!codinomeOrigem) {
      setProdutos([]);
      setTotal(0);
      return;
    }
    setCarregando(true);
    try {
      const filter = { codinome_colaborador_id: codinomeOrigem.id };
      if (categoria) filter.categoria_id = categoria.id;
      if (nomeDebounce) filter.nome = nomeDebounce;
      if (codigoDebounce) filter.codigo = codigoDebounce;
      if (familia) filter.familia_produto_id = familia.id;
      if (local) filter.local_id = local.id;
      if (fornecedor) filter.fornecedor_id = fornecedor.id;
      if (unidade) filter.unidade_id = unidade.id;
      if (estadoFisico) filter.estado_fisico = estadoFisico;

      const response = await getListAPI(
        'produtos/search/por_codinome',
        ['id', 'asc'],
        [paginaAlvo + 1, PRODUTOS_PER_PAGE],
        filter,
        [],
      );

      setProdutos(response.data);
      setTotal(response.total);
    } catch (erros) {
      enqueueSnackbar(`${erros}`, { variant: 'error' });
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    if (open) carregarProdutos();
  }, [
    open,
    page,
    codinomeOrigem,
    categoria,
    nomeDebounce,
    codigoDebounce,
    familia,
    local,
    fornecedor,
    unidade,
    estadoFisico,
  ]);

  useEffect(() => {
    if (open) {
      setPage(0);
      setExcluidos(new Set());
    }
  }, [
    codinomeOrigem,
    categoria,
    nomeDebounce,
    codigoDebounce,
    familia,
    local,
    fornecedor,
    unidade,
    estadoFisico,
  ]);

  useImperativeHandle(ref, () => ({
    handleOpen() {
      reiniciar();
      setOpen(true);
    },
  }));

  function toggleProduto(id) {
    setExcluidos((excluidosAtuais) => {
      const novosExcluidos = new Set(excluidosAtuais);
      if (novosExcluidos.has(id)) novosExcluidos.delete(id);
      else novosExcluidos.add(id);
      return novosExcluidos;
    });
  }

  const idsPagina = produtos.map((produto) => produto.id);
  const todosSelecionadosNaPagina =
    idsPagina.length > 0 && idsPagina.every((id) => !excluidos.has(id));

  function toggleTodosDaPagina() {
    setExcluidos((excluidosAtuais) => {
      const novosExcluidos = new Set(excluidosAtuais);
      if (todosSelecionadosNaPagina) {
        idsPagina.forEach((id) => novosExcluidos.add(id));
      } else {
        idsPagina.forEach((id) => novosExcluidos.delete(id));
      }
      return novosExcluidos;
    });
  }

  function renderCampoFiltro(key) {
    switch (key) {
      case 'categoria':
        return (
          <AutoCompleteRemoto
            label="Categoria"
            value={categoria}
            onChange={(value) => setCategoria(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="categorias"
            nested={[]}
            filters={{}}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'familia':
        return (
          <AutoCompleteRemoto
            label="Família"
            value={familia}
            onChange={(value) => setFamilia(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="familias_produtos"
            nested={[]}
            filters={{}}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'local':
        return (
          <AutoCompleteRemoto
            label="Local/Setor"
            value={local}
            onChange={(value) => setLocal(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="locais_setores"
            nested={[]}
            filters={{ status: STATUS_ATIVO }}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'fornecedor':
        return (
          <AutoCompleteRemoto
            label="Fornecedor"
            value={fornecedor}
            onChange={(value) => setFornecedor(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="fornecedores"
            nested={[]}
            filters={{ status: STATUS_ATIVO }}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'unidade':
        return (
          <AutoCompleteRemoto
            label="Unidade"
            value={unidade}
            onChange={(value) => setUnidade(value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            resource="unidades"
            nested={[]}
            filters={{ status: STATUS_ATIVO }}
            toString={false}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            fullWidth
            margin="none"
          />
        );
      case 'estadoFisico':
        return (
          <FormControl variant="outlined" fullWidth>
            <InputLabel shrink id="estado-fisico-remover-produtos">
              Estado Físico
            </InputLabel>
            <SelectInput
              labelId="estado-fisico-remover-produtos"
              label="Estado Físico"
              handleEnter={() => {}}
              handleKey={() => {}}
              value={estadoFisico}
              onChange={(event) => setEstadoFisico(event.target.value)}
              options={[{ label: 'Todos', value: '' }, ...optionsEstadoFisico]}
            />
          </FormControl>
        );
      case 'codigo':
        return (
          <TextInput
            label="Código de barras"
            value={codigo}
            onChange={(event) => setCodigo(event.target.value)}
            handleKey={() => {}}
            handleEnter={() => {}}
            fullWidth
            margin="none"
          />
        );
      default:
        return null;
    }
  }

  const totalSelecionados = Math.max(total - excluidos.size, 0);

  async function handleRemover() {
    if (!codinomeOrigem) return;
    setSalvando(true);
    try {
      const destino_ids =
        acao === ACAO_DISTRIBUIR
          ? codinomesDestino.map((destino) => destino.id)
          : null;

      const response = await api.put(
        `/codinomes_colaborador/${codinomeOrigem.id}/remover_produtos`,
        {
          categoria_id: categoria ? categoria.id : null,
          nome: nomeDebounce || null,
          codigo: codigoDebounce || null,
          familia_produto_id: familia ? familia.id : null,
          local_id: local ? local.id : null,
          fornecedor_id: fornecedor ? fornecedor.id : null,
          unidade_id: unidade ? unidade.id : null,
          estado_fisico: estadoFisico || null,
          produtos_id_excluidos: Array.from(excluidos),
          destino_ids,
        },
      );
      const { status, message, total: totalRemovido } = response.data;
      if (!status) throw message;

      enqueueSnackbar(
        `${totalRemovido} produto(s) removido(s) do codinome "${codinomeOrigem.nome}" com sucesso!`,
        { variant: 'success' },
      );

      setExcluidos(new Set());
      if (acao === ACAO_DISTRIBUIR) setCodinomesDestino([]);
      setPage(0);
      await carregarProdutos(0);
    } catch (erros) {
      enqueueSnackbar(`${erros}`, { variant: 'error' });
    } finally {
      setSalvando(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      aria-labelledby="remover-produtos-dialog-title"
      classes={{ paper: classes.rootDialogo }}
      className={classes.rootDialogo}
      fullWidth
      maxWidth="md"
      TransitionComponent={Transition}
    >
      <DialogTitle
        id="remover-produtos-dialog-title"
        onClose={handleCloseDialog}
        style={{ backgroundColor: '#009FD4', color: 'white' }}
      >
        Remover Produtos de um Codinome
      </DialogTitle>
      <DialogContent style={{ padding: '0px 36px 20px', margin: '0' }}>
        <Box
          display="flex"
          alignItems="flex-end"
          mt="1em"
          style={{ gap: '16px' }}
        >
          <Box flex={1}>
            <AutoCompleteRemoto
              label="Codinome de origem"
              value={codinomeOrigem}
              onChange={(value) => setCodinomeOrigem(value)}
              handleKey={() => {}}
              handleEnter={() => {}}
              resource="codinomes_colaborador"
              nested={[]}
              filters={{ status: STATUS_ATIVO, turno: TURNO_MANHA }}
              toString={false}
              getOptionSelected={(option, value) => option.id === value.id}
              getOptionLabel={(option) => `${option.nome}`}
              fullWidth
              margin="none"
              perPage={50}
            />
          </Box>
          {codinomeOrigem && (
            <Typography variant="body2" color="textSecondary">
              {totalSelecionados} produto(s) selecionado(s)
            </Typography>
          )}
        </Box>

        {codinomeOrigem && (
          <>
            <Divider style={{ margin: '16px 0' }} />

            <Paper variant="outlined" style={{ padding: '16px' }}>
              <Box display="flex" alignItems="center" style={{ gap: '16px' }}>
                <Box flex={1}>
                  <TextInput
                    label="Nome ou código do produto"
                    value={nome}
                    onChange={(event) => setNome(event.target.value)}
                    handleKey={() => {}}
                    handleEnter={() => {}}
                    fullWidth
                    margin="none"
                  />
                </Box>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={(event) => setAnchorElFiltro(event.currentTarget)}
                  disabled={filtrosAtivos.length === FILTROS_DISPONIVEIS.length}
                >
                  Adicionar filtro
                </Button>
                <Menu
                  anchorEl={anchorElFiltro}
                  open={Boolean(anchorElFiltro)}
                  onClose={() => setAnchorElFiltro(null)}
                >
                  {FILTROS_DISPONIVEIS.filter(
                    (filtro) => !filtrosAtivos.includes(filtro.key),
                  ).map((filtro) => (
                    <MenuItem
                      key={filtro.key}
                      onClick={() => adicionarFiltro(filtro.key)}
                    >
                      {filtro.label}
                    </MenuItem>
                  ))}
                </Menu>
              </Box>

              {filtrosAtivos.length > 0 && (
                <Grid container spacing={2} style={{ marginTop: '8px' }}>
                  {filtrosAtivos.map((key) => (
                    <Grid item xs={12} sm={6} md={4} key={key}>
                      <Box
                        display="flex"
                        alignItems="center"
                        style={{ gap: '4px' }}
                      >
                        <Box flex={1}>{renderCampoFiltro(key)}</Box>
                        <IconButton
                          size="small"
                          onClick={() => removerFiltro(key)}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Paper>

            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginTop: '16px' }}
            >
              {total} produto(s) encontrado(s)
            </Typography>

            <TableContainer
              component={Paper}
              variant="outlined"
              style={{ marginTop: '8px' }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={todosSelecionadosNaPagina}
                        onChange={toggleTodosDaPagina}
                        disabled={produtos.length === 0}
                      />
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold', width: '100px' }}>
                      ID
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Nome</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {carregando ? (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  ) : produtos.length > 0 ? (
                    produtos.map((produto) => (
                      <TableRow key={produto.id} hover>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={!excluidos.has(produto.id)}
                            onChange={() => toggleProduto(produto.id)}
                          />
                        </TableCell>
                        <TableCell>{produto.id}</TableCell>
                        <TableCell>{produto.nome}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        Nenhum produto encontrado para este codinome
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={total}
                page={page}
                onChangePage={(_, newPage) => setPage(newPage)}
                rowsPerPage={PRODUTOS_PER_PAGE}
                rowsPerPageOptions={[]}
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} de ${count}`
                }
              />
            </TableContainer>

            <Divider style={{ margin: '16px 0' }} />

            <FormControl component="fieldset">
              <Typography
                variant="body2"
                style={{ fontWeight: 'bold', marginBottom: '4px' }}
              >
                O que fazer com os produtos selecionados?
              </Typography>
              <RadioGroup
                value={acao}
                onChange={(event) => setAcao(event.target.value)}
              >
                <FormControlLabel
                  value={ACAO_SEM_CODINOME}
                  control={<Radio />}
                  label="Deixar sem codinome"
                />
                <FormControlLabel
                  value={ACAO_DISTRIBUIR}
                  control={<Radio />}
                  label="Distribuir entre outros codinomes"
                />
              </RadioGroup>
            </FormControl>

            {acao === ACAO_DISTRIBUIR && (
              <Box mt="0.5em">
                <AutoCompleteRemoto
                  label="Codinomes de destino"
                  multiple
                  value={codinomesDestino}
                  onChange={(value) =>
                    setCodinomesDestino(
                      (value || []).filter(
                        (destino) =>
                          !codinomeOrigem || destino.id !== codinomeOrigem.id,
                      ),
                    )
                  }
                  handleKey={() => {}}
                  handleEnter={() => {}}
                  resource="codinomes_colaborador"
                  nested={[]}
                  filters={{ status: STATUS_ATIVO, turno: TURNO_MANHA }}
                  toString={false}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => `${option.nome}`}
                  fullWidth
                  margin="none"
                  perPage={50}
                />
              </Box>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions style={{ padding: '0px 36px 20px', margin: '0' }}>
        <div className={classes.wrapper}>
          <Button
            onClick={handleRemover}
            disabled={
              !codinomeOrigem ||
              totalSelecionados === 0 ||
              salvando ||
              (acao === ACAO_DISTRIBUIR && codinomesDestino.length === 0)
            }
            classes={{
              root: classes.btnAtions,
              disabled: classes.btnAtionsDisabled,
            }}
            variant="contained"
            color="primary"
          >
            Remover
          </Button>
          {salvando && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
});

export default DialogoRemoverProdutos;
